<div class="card-content-container">
  <div class="tools-support-description">
    The cards below provide information on how each tool can be used. The cards
    are structured just like the dashboard. Once you click into one of the cards
    below you will see the individual tool card. After clicking into one of the
    tool card, you will see detailed information on how to use a tool.
  </div>

  <div
    class="tool-section"
    [style.backgroundColor]="env['colors']['tool_btn_inactive']"
    *ngIf="
      shouldShowModuleBg(toolListService.successMetricsHelpToolListSignal())
    "
  >
    <div class="tool-header-title">
      <h3>Success Metrics Help</h3>
      <toolbox-menu
        [toolList]="toolListService.successMetricsHelpToolListSignal()"
      />
    </div>
    <ng-template #successMetrics> </ng-template>
  </div>
  <div class="goals-wrapper">
    <goals-list
      [goalsList]="toolListService.successMetricsHelpToolListSignal()"
      [showMoreInfoIcon]="false"
    ></goals-list>
  </div>

  <div
    class="tool-section"
    [style.backgroundColor]="env['colors']['tool_btn_inactive']"
    *ngIf="shouldShowModuleBg(toolListService.adminSupportHelpToolListSignal())"
  >
    <div class="tool-header-title">
      <h3>Admin Support Help</h3>
      <toolbox-menu
        [toolList]="toolListService.adminSupportHelpToolListSignal()"
      />
    </div>
  </div>
  <div class="goals-wrapper">
    <goals-list
      [goalsList]="toolListService.adminSupportHelpToolListSignal()"
      [showMoreInfoIcon]="false"
    ></goals-list>
  </div>

  <div
    class="tool-section"
    [style.backgroundColor]="env['colors']['tool_btn_inactive']"
    *ngIf="
      shouldShowModuleBg(
        toolListService.externalAdminSupportHelpToolListSignal()
      )
    "
  >
    <div class="tool-header-title">
      <h3>Admin Support (External) Help</h3>
      <toolbox-menu
        [toolList]="toolListService.externalAdminSupportHelpToolListSignal()"
      />
    </div>
  </div>
  <div class="goals-wrapper">
    <goals-list
      [goalsList]="toolListService.externalAdminSupportHelpToolListSignal()"
      [showMoreInfoIcon]="false"
    ></goals-list>
  </div>
</div>
